/* ============================================================
   Plush + Oak — Model Overview Collection
   Single-select category navigation. The row of lifestyle tiles
   is the whole control surface; there is no popover to manage.
   ============================================================ */

(function () {
  'use strict';

  function POCollection() {
    return Reflect.construct(HTMLElement, [], POCollection);
  }

  Object.setPrototypeOf(POCollection.prototype, HTMLElement.prototype);
  Object.setPrototypeOf(POCollection, HTMLElement);

  POCollection.prototype.connectedCallback = function () {
    if (this._ready) return;
    this._ready = true;

    /* Only real buttons filter in place; anchors navigate to their own collection. */
    this.tabs = Array.prototype.slice.call(this.querySelectorAll('button[data-pcl-cat]'));
    this.items = Array.prototype.slice.call(this.querySelectorAll('[data-pcl-item]'));
    this.groupWraps = Array.prototype.slice.call(this.querySelectorAll('[data-pcl-groupwrap]'));
    this.emptyEl = this.querySelector('[data-pcl-empty]');

    var self = this;
    this.tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { self.select(tab.dataset.pclCat); });
    });

    // Left/right arrows move between categories, as a tab strip should.
    this.tabs.forEach(function (tab, i) {
      tab.addEventListener('keydown', function (e) {
        var dir = e.key === 'ArrowRight' ? 1 : (e.key === 'ArrowLeft' ? -1 : 0);
        if (!dir) return;
        e.preventDefault();
        var next = self.tabs[(i + dir + self.tabs.length) % self.tabs.length];
        next.focus();
        self.select(next.dataset.pclCat);
      });
    });

    /* Nothing to filter on a nav-only page. */
    if (!this.items.length) return;

    var initial = new URLSearchParams(window.location.search).get('c');
    var valid = this.tabs.some(function (t) { return t.dataset.pclCat === initial; });
    this.select(valid ? initial : 'all', true);
  };

  POCollection.prototype.select = function (key, initial) {
    var self = this;
    this.active = key;

    this.tabs.forEach(function (tab) {
      var on = tab.dataset.pclCat === key;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    var shown = 0;
    this.items.forEach(function (el) {
      var on = key === 'all' || (' ' + (el.dataset.pclCat || '').trim() + ' ').indexOf(' ' + key + ' ') !== -1;
      el.classList.toggle('is-hidden', !on);
      if (on) shown++;
    });

    // A tile group whose every tile is filtered out should take its heading with it.
    this.groupWraps.forEach(function (wrap) {
      var any = Array.prototype.slice
        .call(wrap.querySelectorAll('[data-pcl-item]'))
        .some(function (el) { return !el.classList.contains('is-hidden'); });
      wrap.classList.toggle('is-hidden', !any);
    });

    if (this.emptyEl) this.emptyEl.hidden = shown !== 0;

    if (!initial) {
      // Keep the chosen category in the URL so it can be linked or shared, without
      // discarding any other params the page was opened with.
      var params = new URLSearchParams(window.location.search);
      if (key === 'all') params.delete('c'); else params.set('c', key);
      var qs = params.toString();
      window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));

      // Bring the results back into view when the row sits above the fold.
      var results = self.querySelector('[data-pcl-results]');
      if (results) {
        var top = results.getBoundingClientRect().top;
        if (top < 0) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  if (!window.customElements.get('po-collection')) {
    window.customElements.define('po-collection', POCollection);
  }
})();
